import { store } from '@/app/store'
import type { AppProps } from 'next/app'
import React, { useState, useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider as ReduxProvider } from 'react-redux'
import 'swiper/css'
import 'swiper/css/virtual'
import 'swiper/css/pagination'
import 'tailwindcss/tailwind.css'
import '@/styles/globals.scss'
import '@/styles/Common.scss'
import '@/styles/component/Dialog.scss'
import '@/styles/component/Thumbnail.scss'
import '@/styles/component/Form.scss'
import '@/styles/component/Tag.scss'
import '@/styles/component/Detail.scss'
import '@/styles/component/SwiperMap.scss'
import '@/i18n/config'
import PageView from '@/lib/usePageHooks'
// import { usePageViewAnalytics, GoogleAnalytics } from '@/lib/gtag'

function MyApp({ Component, pageProps }: AppProps) {
  // react-queryのクライアント定義
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      }),
  )

  useEffect(() => {
    const mainColor = `${process.env.NEXT_PUBLIC_MAIN_COLOR || '#ffc600'}`
    document.documentElement.style.setProperty('--main-color', mainColor)
    const subColor = `${process.env.NEXT_PUBLIC_SUB_COLOR || '#000'}`
    document.documentElement.style.setProperty('--sub-color', subColor)
    const mainColor50 = 'color-mix(in srgb, var(--main-color) 50%, transparent)'
    document.documentElement.style.setProperty('--main-color-50', mainColor50)
    const mainColor20 = 'color-mix(in srgb, var(--main-color) 20%, transparent)'
    document.documentElement.style.setProperty('--main-color-20', mainColor20)
  }, [])

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ReduxProvider store={store}>
          <PageView />
          <Component {...pageProps} />
        </ReduxProvider>
      </QueryClientProvider>
    </>
  )
}

export default MyApp
